import React from 'react';

import { IPlazaItemInput } from '@/interface/promotion';

import List from './list';

export const CustomPlazaIndex: React.FC<{
  onChange: (data: IPlazaItemInput[]) => void;
  value: IPlazaItemInput[];
}> = (props) => {
  const { value, onChange } = props;

  const handleChange = (data: IPlazaItemInput) => {
    const hasValue = value?.some(e => e?.id === data?.id);
    let tempValue = value;
    tempValue = value?.map((e) => {
      if (e?.id === data?.id) {
        return data;
      }
      return e;
    }) || [];
    onChange(hasValue ? tempValue : tempValue.concat([data]));
  };

  const handelMove = (id: string) => {
    const index = value?.findIndex(e => e?.id === id);
    if (index > -1) {
      const tempValue = [...value];
      tempValue.splice(index, 1);
      onChange(tempValue);
    }
  };

  const handleSort = (data: IPlazaItemInput[]) => {
    onChange(data);
  };

  return (
    <div>
      <List
        data={value}
        onChange={handleChange}
        onMove={handelMove}
        onSort={handleSort}
      />
    </div>
  );
};
